export default [
    {
        chapter: 'Chapter 01',
        title: 'Title 01',
        duration: '00:03:13',
        file: '/dev-content-files/audiobook/track_01.mp3',
        durationInSecondsPreview: 193,
    },
    {
        chapter: 'Chapter 02',
        title: 'Title 02',
        duration: '00:02:13',
        file: '/dev-content-files/audiobook/track_02.mp3',
        durationInSecondsPreview: 133,
    },
    {
        chapter: 'Chapter 03',
        title: 'Title 03',
        duration: '00:04:12',
        file: '/dev-content-files/audiobook/track_03.mp3',
        durationInSecondsPreview: 252,
    },
];
